import * as React from 'react'
import { observer, inject } from 'mobx-react'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import UserStore from '../../../Stores/UserStore'
import { history } from '../../../Routing'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import AddProductsCreateQ from '../../PartialViews/Questionnaire/AddProductsCreateQ'
import { getQuestionnaireProductsTable } from '../../../Model/CatalogProduct'
import { Button } from 'react-bootstrap'

export interface IEditCreditProductsPageProps {
    questionnairesStore?: QuestionnairesStore
    localizationStore?: LocalizationStore
    httpActionsService?: HttpActionsService
    userStore?: UserStore
    match?: object
}

@inject('questionnairesStore')
@inject('localizationStore')
@inject('httpActionsService')
@inject('userStore')
@observer
class EditCreditProductsPage extends React.Component<IEditCreditProductsPageProps> {
    constructor(props: any) {
        super(props)

        if (!UserStore.getInstance().checkSession) {
            history.push('/login')
        }

        if (this.props['match']!['params']['id']) {
            this.props.httpActionsService!.getQuestionnaire(this.props['match']!['params']['id'])
        } else {
            this.props.httpActionsService!.clearQuestionnaire()
        }
    }

    render() {
        const { questionnairesStore, localizationStore, httpActionsService } = this.props

        let q = questionnairesStore!.getItem

        if (!q) {
            return (
                <div>
                    {localizationStore!.t('no data')}
                </div>)
        }

        return (
            <div className="editCreditProductsPage row">
                <div className="col-12">
                    <Link
                        className="qDetailLink"
                        to={'/questionnaire/' + q.id}
                    >
                        {localizationStore!.t!('Back to Questionnaire')}
                    </Link>
                </div>
                <div className="col-12 blockAddProducts">
                    <AddProductsCreateQ />
                </div>
                <div className="col-12 blockEditCreditProducts">
                    {getQuestionnaireProductsTable()}
                </div>
                <div className="col-12 blockEditCreditProducts">
                    <Button
                        onClick={() => {
                            httpActionsService!.updateCreditProducts(q.credit.id, q.credit.products)
                        }}
                    >
                        {localizationStore!.t('Save')}
                    </Button>
                </div>
            </div>
        )
    }
}

export default withRouter(EditCreditProductsPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Questionnaire/EditCreditProductsPage.tsx